
export const isPhysicalIssuerProduct = (isProdutoDigital?: string) =>
    isProdutoDigital === "N";